/**
 * Do not edit directly
 * Generated on Thu, 24 Oct 2024 00:22:20 GMT
 */
/**
 * Do not edit directly
 * Generated on Thu, 24 Oct 2024 00:22:20 GMT
 */
/**
 * Do not edit directly
 * Generated on Thu, 24 Oct 2024 00:22:20 GMT
 */
/**
 * Do not edit directly
 * Generated on Thu, 24 Oct 2024 00:22:20 GMT
 */
/**
 * Do not edit directly
 * Generated on Thu, 24 Oct 2024 00:22:18 GMT
 */
/* mixins & extensions */
/* helper to properly scale internal durations */
/**
* Currently only used in Checkbox.
*/
/**
* CSS Custom Properties
*
* These properties can be overridden using the component's tag as selector.
*
* @prop --calcite-tooltip-z-index: Sets the z-index value for the component.
*/
:host {
  --calcite-floating-ui-z-index: var(--calcite-tooltip-z-index, var(--calcite-z-index-tooltip));
  display: block;
  position: absolute;
  z-index: var(--calcite-floating-ui-z-index);
}

.calcite-floating-ui-anim {
  position: relative;
  transition: var(--calcite-floating-ui-transition);
  transition-property: inset, left, opacity;
  opacity: 0;
  box-shadow: 0 0 16px 0 rgba(0, 0, 0, 0.16);
  z-index: var(--calcite-z-index);
  border-radius: 0.25rem;
}

:host([data-placement^=bottom]) .calcite-floating-ui-anim {
  inset-block-start: -5px;
}

:host([data-placement^=top]) .calcite-floating-ui-anim {
  inset-block-start: 5px;
}

:host([data-placement^=left]) .calcite-floating-ui-anim {
  left: 5px;
}

:host([data-placement^=right]) .calcite-floating-ui-anim {
  left: -5px;
}

:host([data-placement]) .calcite-floating-ui-anim--active {
  opacity: 1;
  inset-block: 0;
  left: 0;
}

:host([calcite-hydrated-hidden]) {
  visibility: hidden !important;
  pointer-events: none;
}

.calcite-floating-ui-arrow {
  pointer-events: none;
  position: absolute;
  z-index: calc(var(--calcite-z-index) * -1);
  fill: var(--calcite-color-foreground-1);
}

.calcite-floating-ui-arrow__stroke {
  stroke: var(--calcite-color-border-3);
}

.container {
  position: relative;
  overflow: hidden;
  border-radius: 0.25rem;
  padding-block: 0.75rem;
  padding-inline: 1rem;
  font-size: var(--calcite-font-size--2);
  line-height: 1.375;
  font-weight: var(--calcite-font-weight-medium);
  color: var(--calcite-color-text-1);
  max-inline-size: 20rem;
  max-block-size: 20rem;
  text-align: start;
}

.calcite-floating-ui-anim {
  border-radius: 0.25rem;
  border-width: 1px;
  border-style: solid;
  border-color: var(--calcite-color-border-3);
  background-color: var(--calcite-color-foreground-1);
}

.arrow::before {
  outline: 1px solid var(--calcite-color-border-3);
}

:host([hidden]) {
  display: none;
}

[hidden] {
  display: none;
}